import View from './MultiSelect';
import enhancer from './MultiSelect.enhancer';

const MultiSelect = enhancer(View);

export default MultiSelect;
